import API from "../../../../../global/api";
import jsPDF from "jspdf";
import _ from "lodash";
import "jspdf-autotable";


export const requestAddProductionReceiving = () => {
    return {
        type: "REQUEST_ADD_PRODUCTION_RECEIVING",
    };
};
export const successAddProductionReceiving = (data) => {
    return {
        type: "SUCCESS_ADD_PRODUCTION_RECEIVING",
        payload: data,
    };
};
export const errorAddProductionReceiving = () => {
    return {
        type: "ERROR_ADD_PRODUCTION_RECEIVING",
    };
};
export const AddProductionReceivingApi = (data, handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(requestAddProductionReceiving());
        API.post(`/productionReceiving`, data).then((res) => {
            dispatch(successAddProductionReceiving(data));
            handleVisible(res.data.message);
        }).catch((error) => {
            dispatch(errorAddProductionReceiving());
            handleDangerVisible(error.response.data.message);
        })
    };
};


export const requestGetProductionReceiving = () => {
    return {
        type: "REQUEST_GET_PRODUCTION_RECEIVING",
    };
};
export const successGetProductionReceiving = (data) => {
    return {
        type: "SUCCESS_GET_PRODUCTION_RECEIVING",
        payload: data,
    };
};
export const errorGetProductionReceiving = () => {
    return {
        type: "ERROR_GET_PRODUCTION_RECEIVING",
    };
};
export const GetProductionReceivingApi = () => {
    return (dispatch) => {
        dispatch(requestGetProductionReceiving());
        API.get(`/productionReceiving`).then((res) => {
            let getData = res.data;
            dispatch(successGetProductionReceiving(getData));
        }).catch((error) => {
            dispatch(errorGetProductionReceiving());
        })
    };
};


export const requestProductionReceivingReport = () => {
    return {
        type: "REQUEST_PRODUCTION_RECEIVING_REPORT",
    };
};
export const successProductionReceivingReport = (data) => {
    return {
        type: "SUCCESS_PRODUCTION_RECEIVING_REPORT",
        payload: data,
    };
};
export const errorProductionReceivingReport = () => {
    return {
        type: "ERROR_PRODUCTION_RECEIVING_REPORT",
    };
};
export const ReceivingReportApi = (payload) => {
    return (dispatch) => {
        dispatch(requestProductionReceivingReport());
        API.post(`/productionReceiving/receiving-report`, payload).then((res) => {
            const data = res.data
            dispatch(successProductionReceivingReport(data));
        }).catch((error) => {
            dispatch(errorProductionReceivingReport());
        })
    };
};


export const PrintSingleProductionReceiving = (data) => {
    return (dispatch) => {
        const unit = "pt";
        const size = "A4";
        const orientation = "potrait";
        const doc = new jsPDF(orientation, unit, size);
        const title = "Production Receiving Details";
        const companyName = `${process.env.REACT_APP_COMPANY_NAME}`;
        const companyAddress = `${process.env.REACT_APP_COMPANY_ADDRESS}`;
        const companyNtn = `${process.env.REACT_APP_COMPANY_NTN}`;
        const sequenceNumber = "Receiving No: " + data.sequenceNumber;
        const receivingDate = "Receiving Date: " + data.issuanceDate;
        const vendorName = "Vendor Name: " + data?.vendorDetails?.vendorName;
        const orderNumber = "Order No.: " + data?.orderDetails?.orderNumber;

        const headers = [[
            "Sr",
            "Article Name",
            "Received Quantity",
        ]];
        const prodactData = _.isEmpty(data?.orderDetails?.articleIssuanceDetails) ? [] : data?.orderDetails?.articleIssuanceDetails.map((elt, i) => [
            i + 1,
            elt.articleName,
            elt.recevingQuantity,
        ]);
        if (!_.isEmpty(prodactData)) {
            prodactData.push(["Total", "", Math.round(_.sumBy(prodactData, '2') * 100) / 100])
        }
        let ProductContent = {
            startY: 200,
            startX: 50,
            head: headers,
            styles: { fontSize: 11 },
            body: prodactData,
            theme: "grid",
            headStyles: { fillColor: "#2980ba" },
        };
        doc.autoTable(ProductContent);

        // doc.addImage(logo, "PNG", 40, 15, 80, 80);
        doc.text(companyName, 150, 40, 0, 20);
        doc.setFontSize(12);
        doc.setFont("Times New Roman", "normal");
        doc.text(companyAddress, 150, 58, 0, 20);
        doc.text(companyNtn, 150, 80, 0, 20);
        doc.setFontSize(14);
        doc.setFont("Times New Roman", "bold")
        doc.text(title, 240, 120);
        doc.setFontSize(12);
        doc.setFont("Times New Roman", "normal")
        doc.text(sequenceNumber, 50, 150, 0, 20);
        doc.text(receivingDate, 330, 150, 0, 20);
        doc.text(vendorName, 50, 170, 0, 20);
        doc.text(orderNumber, 330, 170, 0, 20);


        doc.setProperties({ title: `Production Receiving PDF` });
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
    };
};